module.exports = __webpack_public_path__ + "img/blade_diffuse.08d29cf2.jpg";